import React, { Component, useContext } from 'react';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../components/GlobalContext';
import * as $ from 'jquery';
import * as MySound from '../components/MySound';

export class ToteApproval extends Component {
    static displayName = ToteApproval.name;

    allowLoginLevel = ["MM", "SM"];

    constructor(props) {
        super(props);
        this.state = { inwardData: [], toteData: [], inwardID: '', toteText: '', alertMessage:"" };
        this.history = props.history;

    }

    componentDidMount() {
        this.populateInwardData();
    }

    txtKeyPressed(e) {
        if (e?.which == 13) {
            this.gotoMoveQC();
        }
    }

    gotoMoveQC() {
        if (this.state.toteText.trim().length > 0 && MyGlobal.userAllowed(this.allowLoginLevel)) {
            this.history.push('ToteMoveQC', { tote: this.state.toteText });
        } else {
            this.setState({ alertMessage: MyGlobal.strings.requiresSupervisor, toteText: "" });
        }
    }

    renderInwardTable(data) {
        return (
            <table className='table table-striped' aria-labelledby="tabelLabel">
                <thead>
                    <tr>
                        <th>Inwards Ref</th>
                        <th>Client</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map(row =>
                        <tr key={row.InwardsId}
                            onClick={(e, key) => {
                                $(e.currentTarget).closest("table").find("tr").removeClass("selected");
                                $(e.currentTarget).addClass("selected");
                                this.state.inwardID = row.InwardsId;
                                this.state.alertMessage = "";
                                this.populateToteData();
                                this.txtTote.focus();
                            }}>
                            <td>{row.InwardsRef}</td>
                            <td>{row.NAME}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }

    renderToteTable(data) {
        return (
            <table className='table table-striped' aria-labelledby="tabelLabel">
                <thead>
                    <tr>
                        <th>Tote</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map(row =>
                        <tr key={row.Tote}
                            onClick={(e, key) => {
                                $(e.currentTarget).closest("table").find("tr").removeClass("selected");
                                $(e.currentTarget).addClass("selected");
                                this.state.toteText = row.Tote;
                                this.gotoMoveQC();
                            }}>
                            <td>{row.Tote}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }

    render() {

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        let inwardContents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderInwardTable(this.state.inwardData);
        let toteContents = this.state.toteData.length == 0
            ? <p><em>Select Inward</em></p>
            : this.renderToteTable(this.state.toteData);

        return (
            <div>
                <MyHeading>Select Inward</MyHeading>
                <br />
                {alertMessage}
                <div className="form-group">
                    <label htmlFor="txtTote">Tote</label>
                    <input
                        type="text"
                        value={this.state.toteText}
                        onChange={(e) => {
                            this.setState({ toteText: e.target.value });
                        }}
                        onKeyPress={(e) => { this.txtKeyPressed(e); }}
                        className="form-control"
                        name="txtTote"
                        id="txtTote"
                        autoFocus
                        ref={(input) => { this.txtTote = input; }}
                    />
                </div>
                 <div className="tableHolder hm-40vh mb-3">
                    {inwardContents}
                </div>
                <div className="tableHolder hm-40vh mb-3">
                    {toteContents}
                </div>
            </div>
        );
    }

    async populateInwardData() {
        //   const token = await authService.getAccessToken();

        var warehouseID = MyGlobal.warehouse;
        var inwardID = this.state.inwardID;
        var url = `api/Tote/GetMoveReceiptInwardsRecounts?warehouseID=${warehouseID}&inwardID=${inwardID}`;
        const response = await fetch(url, {
            //      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        this.setState({ inwardData: data, loading: false });
    }

    async populateToteData() {
        //   const token = await authService.getAccessToken();
        var warehouseID = MyGlobal.warehouse;
        var inwardID = this.state.inwardID;
        var url = `api/Tote/GetMoveReceiptTotesRecounts?warehouseID=${warehouseID}&inwardID=${inwardID}`;
        const response = await fetch(url, {
            //      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        this.setState({ toteData: data, loading: false });
    }

}
